import { validateBalance } from './balance/validate'
import { validateSeaPassages } from './sea-passages'

export { ContentValidationError } from './errors'
export { CONTENT_HASH } from './hash'
export { LAND_NAVIGATION, type LandNavigation, type LandNavigationLane, type LandNavigationSite } from './navigation'
export type { LatLon, PathPose, SurfacePath, SurfacePathKind } from './geometry/routes'
export {
  ALL_CITIES,
  CITY_BY_ID,
  COUNTRIES,
  LAND_MASK,
  LandMask,
  MIN_CITIES_PER_BELLIGERENT,
  PLAYABLE_COUNTRIES,
  WORLD_NETWORK_CANDIDATES,
  type City,
  type CityId,
  type Country,
  type CountryCode,
} from './geo'
export { HARBOUR_BAKE, HARBOURS, type Harbour } from './harbours'
export { WORLD_OCEAN_CROSSING_LEGS } from './ocean-crossings'
export { SEA_PASSAGES, type SeaPassage } from './sea-passages'
export * from './balance/keys'
export * from './balance/tables'

validateBalance()
validateSeaPassages()
